import { shuffleArray, Topic } from '@news-mono/web-common'
import React from 'react'
import { useLocation } from 'react-router'
import { Tag } from '../../buttons/Tag/Tag'
import {
    StyledHeader,
    StyledTopicListContainer,
    StyledTopicNav,
} from '../../content/TopicList/TopicList.styled'
import { ThemeOverrider } from '../../themes/ThemeOverrider/ThemeOverrider'
import { getBauhausThemeOverride } from '../../__styling/get-bauhaus-theme-override'
import { ThemeMargins } from '../../__styling/settings/metrics'
import { ThemedRender } from '../../__styling/themed-render'

export interface TopicListProps {
    primaryTopic?: Topic
    secondaryTopics?: Topic[]
    verticalSpacing?: keyof ThemeMargins
}

export const TopicList: React.FC<TopicListProps> = ({
    primaryTopic,
    secondaryTopics = [],
    verticalSpacing,
}) => {
    const location = useLocation()
    const themeOverride = getBauhausThemeOverride(location.pathname)

    if (!primaryTopic && secondaryTopics.length === 0) {
        return null
    }

    let secondaryTopicsList = secondaryTopics.filter((topic) => {
        if (primaryTopic) {
            return topic.id !== primaryTopic.id
        }
        return true
    })

    // DPT-2180 - reduce the number of topics if there are a large amount of topics, cap at 6,
    // they will be shuffled to ensure distribution of potential topic listing click throughs
    if (secondaryTopics.length > 6) {
        secondaryTopicsList = shuffleArray(secondaryTopicsList)
    }

    return (
        <StyledTopicListContainer
            className="topic-list hide-print"
            verticalSpacing={verticalSpacing}
        >
            <ThemeOverrider override={themeOverride}>
                <ThemedRender
                    perthnow={() => <StyledHeader>Topics</StyledHeader>}
                    thewest={() => null}
                    sevennews={() => null}
                />
                <StyledTopicNav>
                    {primaryTopic ? <Tag topic={primaryTopic} /> : undefined}

                    {secondaryTopicsList.map((topic) => (
                        <Tag key={topic.id} topic={topic} />
                    ))}
                </StyledTopicNav>
            </ThemeOverrider>
        </StyledTopicListContainer>
    )
}
TopicList.displayName = 'TopicList'
